var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "6rf6ygalrc",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F8297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FA844E"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bxb6tts8na",
    width: "154.1%",
    height: "166.7%",
    x: "-27%",
    y: "-26.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.996078431 0 0 0 0 0.392156863 0 0 0 0 0.223529412 0 0 0 0.50704764 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ub08youyyb",
    width: 37,
    height: 30,
    x: 0,
    y: 0,
    rx: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-793.000000, -23.000000) translate(25.000000, 22.000000) translate(579.000000, 5.000000) translate(195.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bxb6tts8na)",
    xlinkHref: "#ub08youyyb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#6rf6ygalrc)",
    xlinkHref: "#ub08youyyb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EFF2F8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.5c4.562 0 8.25 3.697 8.25 8.25 0 4.555-3.688 8.25-8.25 8.25-4.554 0-8.25-3.695-8.25-8.25 0-4.553 3.696-8.25 8.25-8.25zm0 10.668c-.396 0-.718.322-.718.718 0 .396.322.726.726.726.396 0 .718-.33.718-.726 0-.396-.322-.718-.726-.718zm0-6.27c-.396 0-.726.33-.726.725v3.647c0 .397.33.718.726.718.396 0 .718-.321.718-.718V7.623c0-.395-.322-.726-.718-.726z",
    transform: "translate(-793.000000, -23.000000) translate(25.000000, 22.000000) translate(579.000000, 5.000000) translate(195.000000, 0.000000) translate(8.000000, 5.000000)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.42552aed.svg";
export { ForwardRef as ReactComponent };